function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.4,
  d: "M16.1898 2H7.81976C4.17976 2 2.00977 4.17 2.00977 7.81V16.18C2.00977 19.82 4.17976 21.99 7.81976 21.99H16.1898C19.8298 21.99 21.9998 19.82 21.9998 16.18V7.81C21.9998 4.17 19.8298 2 16.1898 2Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22 10.1599H14.33C14.32 10.0899 14.32 10.0099 14.3 9.93991C14.09 9.13991 13.44 8.48991 12.64 8.27991C11.2 7.89991 9.89001 8.83991 9.67001 10.1599H2V11.6599H9.91C10.11 12.0399 10.39 12.3599 10.75 12.5799V14.5599C10.75 15.2499 11.31 15.8099 12 15.8099C12.69 15.8099 13.25 15.2499 13.25 14.5599V12.5799C13.61 12.3599 13.89 12.0399 14.09 11.6599H22V10.1599Z",
  fill: "white"
});

var SvgNoptienActive = function SvgNoptienActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoptienActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noptien_active.b9dabd98.svg";
export { ForwardRef as ReactComponent };